<template>
    <svg t="1566562392684" class="icon" viewBox="0 0 1544 1024" version="1.1" p-id="2809" width="301.5625" height="200">
        <path d="M 607.233 892.701 a 134.815 134.815 0 0 1 -190.466 0 L 131.299 607.233 a 134.815 134.815 0 0 1 0 -190.466 L 416.767 131.299 a 134.815 134.815 0 0 1 190.466 0 l 285.469 285.469 a 134.815 134.815 0 0 1 0 190.466 a 45.9729 45.9729 0 0 0 65.0286 65.0286 a 226.922 226.922 0 0 0 0 -320.523 L 672.261 66.2699 a 226.922 226.922 0 0 0 -320.523 0 L 66.2699 351.693 a 226.922 226.922 0 0 0 0 320.523 L 351.693 957.73 a 226.922 226.922 0 0 0 320.523 0 a 45.9729 45.9729 0 0 0 -65.0286 -65.0286 Z" fill="#5f6f5f" p-id="2810"></path>
        <path d="M 1478.03 351.693 L 1192.56 66.2699 a 226.922 226.922 0 0 0 -320.523 0 a 45.9729 45.9729 0 1 0 65.0286 65.0286 a 134.815 134.815 0 0 1 190.466 0 l 285.492 285.469 a 134.861 134.861 0 0 1 0 190.466 l -285.492 285.469 a 134.815 134.815 0 0 1 -190.466 0 L 651.597 607.233 a 134.815 134.815 0 0 1 0 -190.466 A 45.9729 45.9729 0 1 0 586.568 351.693 a 226.922 226.922 0 0 0 0 320.523 l 285.469 285.515 a 226.922 226.922 0 0 0 320.523 0 L 1478.03 672.261 A 226.922 226.922 0 0 0 1478.03 351.693 Z" fill="#1296db" p-id="2811"></path>
    </svg>
</template>

<script>
export default {
  name: 'correlateicon',
  components: {
  },
  created() {
  }
}
</script>
